import React, { useEffect, useState } from 'react';
import api from '../../../services/api';
import { useAuthStore } from '../../../stores/authStore';

/** 老用户（注册时还不要邮箱）的提示条：绑定邮箱后才能用邮箱登录和找回密码 */
export const EmailBindBanner: React.FC = () => {
  const { user, updateUser } = useAuthStore();
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [cooldown, setCooldown] = useState(0);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<{ ok: boolean; text: string } | null>(null);

  useEffect(() => {
    if (cooldown <= 0) return;
    const t = setTimeout(() => setCooldown(c => c - 1), 1000);
    return () => clearTimeout(t);
  }, [cooldown]);

  if (!user || user.email || dismissed) return null;

  const fail = (e: any) => setMsg({ ok: false, text: e?.response?.data?.message || '操作失败，请重试' });

  const sendCode = async () => {
    setBusy(true);
    setMsg(null);
    try {
      await api.post('/users/email-code', { email: email.trim() });
      setCooldown(60);
      setMsg({ ok: true, text: '验证码已发送，请查收邮件' });
    } catch (e) {
      fail(e);
    } finally {
      setBusy(false);
    }
  };

  const bind = async () => {
    setBusy(true);
    setMsg(null);
    try {
      const r = await api.post('/users/email', { email: email.trim(), code: code.trim() });
      updateUser({ ...user, email: r.data.email });
    } catch (e) {
      fail(e);
    } finally {
      setBusy(false);
    }
  };

  const field = 'px-2 py-1.5 text-xs border border-amber-200 rounded-md bg-white focus:outline-none focus:border-blue-500';

  return (
    <div className="mb-6 p-3 rounded-lg border border-amber-200 bg-amber-50 text-sm text-amber-900">
      <div className="flex items-center justify-between gap-3">
        <span>你的账号还没有绑定邮箱。绑定后可以用邮箱登录，忘记密码时也能找回。</span>
        <div className="flex gap-2 shrink-0">
          {!open && <button onClick={() => setOpen(true)} className="px-3 py-1 text-xs rounded-md bg-amber-500 text-white hover:bg-amber-600">绑定邮箱</button>}
          <button onClick={() => setDismissed(true)} className="px-3 py-1 text-xs rounded-md bg-white border border-amber-200 text-amber-800 hover:bg-amber-100">稍后</button>
        </div>
      </div>
      {open && (
        <div className="mt-3 flex flex-wrap items-center gap-2">
          <input value={email} onChange={e => setEmail(e.target.value)} type="email" placeholder="邮箱" className={`${field} w-56`} />
          <button disabled={busy || cooldown > 0 || !email.trim()} onClick={sendCode} className="px-3 py-1.5 text-xs rounded-md bg-white border border-amber-300 hover:bg-amber-100 disabled:opacity-50">
            {cooldown > 0 ? `${cooldown} 秒后重发` : '发送验证码'}
          </button>
          <input value={code} onChange={e => setCode(e.target.value)} inputMode="numeric" maxLength={6} placeholder="6位验证码" className={`${field} w-28`} />
          <button disabled={busy || code.trim().length !== 6} onClick={bind} className="px-3 py-1.5 text-xs rounded-md bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50">确认绑定</button>
          {msg && <span className={`text-xs ${msg.ok ? 'text-green-700' : 'text-red-600'}`}>{msg.text}</span>}
        </div>
      )}
    </div>
  );
};
